import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {addNotification, loadingApplication} from '@componentDP/js_react/redux/actions/application';
import FieldFileDropzone from '../simple/fields/field_multiple_file/dropzone';
import FormLabel from '@material-ui/core/FormLabel';
import {
    changeFilesNotTemporaryStatus, combineUploadFileInfoWithApiFile,
    deleteFileRequest,
    deleteFilesRequest, getFilesInfoFromSprByFileIds,
    saveFilesRequest,
} from '@services/filemanager';
import { isEmpty } from 'lodash';
import FieldFileDropzoneTable from '../simple/fields/field_multiple_file/table';
import {modifyZajavl} from '@componentDP/js_react/redux/actions/zajavls';
import {filesInfoReceived} from '@componentDP/js_react/redux/actions/files';
import {FilemanagerApi} from '@requests';
import {withTranslation} from "react-i18next";

class ZajavlFiles extends Component {
    constructor({filesSpr, zajavl, successSaveCallback}) {
        super();
        let fileIds = [];
        if (zajavl.hasOwnProperty('file_ids') && !isEmpty(zajavl.file_ids) && Array.isArray(zajavl.file_ids)) {
            fileIds = zajavl.file_ids;
        }
        this.state = {
            files: getFilesInfoFromSprByFileIds(fileIds, filesSpr),
            ids_for_delete: [],
        };
        successSaveCallback(this.successSaveCallback.bind(this));
    }

    successSaveCallback = async () => {
        const {apiDomainFilemanager} = this.props;
        const {ids_for_delete: idsForDelete, files} = this.state;
        if (!isEmpty(idsForDelete)) {
            await deleteFilesRequest(idsForDelete, apiDomainFilemanager);
        }
        const idsForSave = files.map(({id}) => id);
        if (!isEmpty(idsForSave)) {
            await changeFilesNotTemporaryStatus(idsForSave, apiDomainFilemanager);
        }
        const result = files.map(file => {
            return {...file, confirmed: true}
        });
        this.setState({...this.state, ids_for_delete: [], files: result});
    };

    handleRemoveFile = async (removeFileId) => {
        const state = this.state;
        const {zajavl, modifyZajavl, loadingApplication} = this.props;
        const {files} = state;
        const file = files.find(({id}) => id === removeFileId);
        if (file) {
            if (!file.confirmed) {
                loadingApplication(true);
                const {apiDomainFilemanager} = this.props;
                const deleteResult = await deleteFileRequest(removeFileId, apiDomainFilemanager);
                if (!deleteResult.hasOwnProperty('error')) {
                    const result = files.filter(({id}) => id !== removeFileId);
                    const fileIds = result.map(({id}) => id);
                    modifyZajavl(zajavl.uuid, {file_ids: fileIds});
                    this.setState({...state, files: result});
                } else {
                    this.props.addNotification({message: deleteResult.error, type: 'error'});
                }
                loadingApplication(false);
            } else {
                const { ids_for_delete: idsForDelete } = state;
                const result = files.filter(({id}) => id !== removeFileId);
                idsForDelete.push(removeFileId);
                this.setState({...state, ids_for_delete: idsForDelete, files: result});
                const fileIds = result.map(({id}) => id);
                modifyZajavl(zajavl.uuid, {file_ids: fileIds});
            }
        }
    };

    handleDownloadFile = async (fileId) => {
        const {apiDomainFilemanager} = this.props;
        const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
        await filemanagerApi.downloadFile(fileId);
    };

    onDrop = async (acceptedFiles) => {
        const {vuzId, apiDomainFilemanager, zajavl, modifyZajavl, loadingApplication, t} = this.props;
        loadingApplication(true);
        const requestsPayload = await saveFilesRequest(acceptedFiles, vuzId, apiDomainFilemanager);
        const state = this.state;
        const files = [...state.files];
        const newApiFileSpr = [];
        requestsPayload.forEach(requestPayload => {
            const {result: requestResult, file} = requestPayload;
            if (!requestResult.hasOwnProperty('error')) {
                const formattedFileInfo = {
                    ...combineUploadFileInfoWithApiFile(requestResult, file),
                    confirmed: false,
                };
                files.push(formattedFileInfo);
                newApiFileSpr.push(requestResult);

                if (!!zajavl.id) {
                    this.props.addNotification({message: t('submit_application_reminder'), type: 'info'});
                }
            } else {
                const error = `Файл: ${file.name}:<br>${requestResult.error}`;
                this.props.addNotification({message: error, type: 'error'});
            }
        });
        if (!isEmpty(newApiFileSpr)) {
            this.props.filesInfoReceived(newApiFileSpr);
        }
        const fileIds = files.map(({id}) => id);
        modifyZajavl(zajavl.uuid, {file_ids: fileIds});
        this.setState({...state, files});
        loadingApplication(false);
    };

    render() {
        const {files} = this.state;
        const {zajavl, t} = this.props;
        let filesTable = !isEmpty(files)
            ? <FieldFileDropzoneTable files={files}
                                      showDeleteBtn={typeof zajavl.id === 'undefined' || (zajavl.is_save_without_send_allowed || zajavl.is_save_and_send_allowed)}
                                      handleRemoveFile={this.handleRemoveFile} handleDownloadFile={this.handleDownloadFile} />
            : null;
        const dropzone = (typeof zajavl.id === 'undefined' || (zajavl.is_save_without_send_allowed || zajavl.is_save_and_send_allowed))
            ? <FieldFileDropzone onDrop={this.onDrop}/>
            : null;
        if (typeof zajavl.id !== 'undefined' && (zajavl.is_save_without_send_allowed === false || zajavl.is_save_and_send_allowed === false)  && filesTable === null) {
            filesTable = <div>
                {t('no_files_uploaded')}
            </div>
        }
        return (
            <React.Fragment>
                <FormLabel component="legend">{t('uploaded_files')}</FormLabel>
                {dropzone}
                {filesTable}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        vuzId: state.vuzId,
        filesSpr: state.files,
        apiDomainFilemanager: state.apiDomainFilemanager,
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    addNotification,
    loadingApplication,
    modifyZajavl,
    filesInfoReceived,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ZajavlFiles));
